@use '@design/design-tokens/typography/typography' as *;

.body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 20px;
}

.description {
  @include typography-v2-body-base;
  color: var(--text-default);
  margin: 0;
}

// ── Task card ─────────────────────────────────────────────────────────────────

.taskCard {
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
}

.taskCardTop {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: var(--surface-default);
  min-height: 72px;
  justify-content: center;
}

.taskTitleRow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-default);
  min-width: 0;
}

.taskTitle {
  @include typography-v2-title-md;
  color: var(--text-default);
  max-width: 450px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taskCadenceRow {
  padding-left: 28px;
}

.taskCadence {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taskCardBottom {
  padding: 12px;
  background: var(--surface-soft);
  border-top: 1px solid var(--border-soft);
}

.tooltipLabel {
  width: 290px;
  @include typography-v2-body-sm;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-soft);
}
